import React from "react";
import Header from "./Header";
import Footer from "./Footer";

class Contact extends React.Component {
  render() {
    return (
      <div>
        <Header />
        <div className="container">
          <h1 className="heading serif-font">
            Contact / Production Collaborators
          </h1>
          <p>
            Neuehouse
            <br />
            Gallery Suite
            <br />
            110 East 25th Street
            <br />
            New York NYC 10010
          </p>
          <br />
          <p>
            <span>Phone: </span>
            917 553 0646
          </p>
          <br />
          <p>
            <span>E-Mail: </span>
            <a
              href="mailto:estelle@estelleleeds.com"
              title="Opens window for sending email"
            >
              estelle@estelleleeds.com
            </a>
          </p>
          <br />
          <p className="serif-italic-font">Estelle Leeds PR by PMK LA</p>
          <br />
          <br />
          <p>
            Estelle Leeds Management is a full-service creative production
            vehicle built around cinematic storytelling, photography, and
            integrated campaign development.
            <br /> <br />
            We collaborate with a network of production companies, service
            companies, producers, artists, and creative partners globally —
            assembling the right team and production approach for each project.
            <br /> <br />
            See below some of our production collaborators whom we pair together
            for the right fit on specific projects:
            <br /> <br />
            AFTER HOURS
            <br />
            WANTED INTERNATIONAL
            <br />
            NATIVECONTENT <br />
            CDMX/ FFFONDO <br />
            FIGHT FILMS <br />
            MAI
            <br />
            LOLA
            <br />
            HENRY PARIS
            <br />
            LA BELLE FACON
            <br />
            MINI CONTENT{" "}
          </p>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Contact;
